import { project2BaseUrl } from './remoteClient'

export async function proficienciesRequest(token) {
    return await project2BaseUrl.get('/administration/getProficiencies', {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}